<template>
  <TierUpgradeModal />
  <RegWallModal />
  <StartProjectModal @startSelected="startProject" />
  <PaymentsModal />
  <GenericConfirmationModal />
  <GenericSendEmailModal />
  <ShareByInstagramModal />
  <DesignerModal />
  <AddPortfolioProjectModal />
  <EditPortfolioProjectModal />
  <SpoakSignModal />

  <ClientInfoModal />
  <KudosModal />
  <DesignerKudosModal />
  <ShareToFeedModal />
  <SubmitToFeedModal />
  <ExportVideoModal />
  <MembershipCardModal />
  <RichShareModal />
  <NewViziModal />
  <NewProjectModal />
  <SlideshowModal />
  <AddThingToProjectModal />
  <CreateInvoiceModal />
  <InvoiceAmountModal />
  <TermsModal />
  <ImageSelectModal />
  <MoreLikeThisModal />
  <WelcomeModal />
  <ProjectWizardModal />

  <!-- things detail modals -->
  <ImageDetailModal />
  <EditImageModal />
  <PaletteDetailModal />
  <EditProductModal />
  <EditProjectProductModal />
  <ViziDetailModal />

  <AddBudgetItemModal />
  <EditBudgetItemModal />

  <PaperformModal />
  <GenericModal />
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router'
import { StartProjectModal } from '/@/common/projects/ProjectModal'
import { PaymentsModal } from '/@/core/payments'
import GenericModal from '/@/core/modals/GenericModal'
import GenericSendEmailModal from '/@/core/modals/GenericSendEmailModal'
import GenericConfirmationModal from '/@/common/modals/GenericConfirmationModal'
import ShareByInstagramModal from '/@/common/modals/ShareByInstagramModal'
import ExportVideoModal from '/@/pages/Project/common/elements/ExportVideoModal'
import DesignerModal from '/@/common/modals/DesignerModal'
import {
  AddPortfolioProjectModal,
  EditPortfolioProjectModal,
} from '/@/common/modals/PortfolioProjectModal'
import SpoakSignModal from '/@/common/modals/SpoakSignModal'
import ImageDetailModal from '/@/common/modals/things/ImageDetailModal'
import PaletteDetailModal from '/@/common/modals/things/PaletteDetailModal'
import ViziDetailModal from '/@/common/modals/things/ViziDetailModal'
import KudosModal from '/@/common/modals/KudosModal'
import DesignerKudosModal from '/@/common/modals/DesignerKudosModal'
import ShareToFeedModal from '/@/common/modals/ShareToFeedModal'
import SubmitToFeedModal from '/@/common/modals/SubmitToFeedModal'
import RegWallModal from '/@/common/modals/RegWallModal'
import MembershipCardModal from '/@/common/modals/MembershipCardModal'
import RichShareModal from '/@/common/modals/RichShareModal'
import {
  useNewViziModal,
  NewViziModal,
} from '/@/common/viz/modals/NewViziModal'
import { NewProjectModal } from '/@/common/projects/modals/NewProjectModal'
import SlideshowModal from '/@/common/modals/SlideshowModal'
import AddThingToProjectModal from '/@/common/projects/modals/AddThingToProjectModal'
import ClientInfoModal from '/@/common/modals/ClientInfoModal'
import { useProjectGuard } from '/@/common/projects/utils'
import CreateInvoiceModal from '/@/common/modals/CreateInvoiceModal'
import InvoiceAmountModal from '/@/common/modals/InvoiceAmountModal'
import TermsModal from '/@/common/modals/TermsModal'
import EditImageModal from '/@/common/modals/EditImageModal'
import EditProductModal from '/@/common/modals/EditProductModal'
import EditProjectProductModal from '/@/common/modals/EditProjectProductModal'
import PaperformModal from '/@/common/modals/PaperformModal'
import ImageSelectModal from '/@/common/modals/ImageSelectModal'
import MoreLikeThisModal from '/@/common/modals/MoreLikeThisModal'
import TierUpgradeModal from '/@/common/modals/TierUpgradeModal'
import WelcomeModal from '/@/common/modals/WelcomeModal'
import ProjectWizardModal from '/@/common/projects/modals/ProjectWizardModal'
import {
  AddBudgetItemModal,
  EditBudgetItemModal,
} from '/@/common/budget/modals'

const router = useRouter()
const projectGuard = useProjectGuard()
const newViziModal = useNewViziModal()

async function startProject({ url }: { projectId: string; url: string }) {
  if (url.startsWith('http')) {
    window.location.href = url
  } else {
    if (url.startsWith('/vizi/create')) {
      try {
        await projectGuard.verify('Vizi')
      } catch {
        return
      }
      newViziModal.show()
      return
    }
    router.push(url)
  }
}
</script>
